import { defineBlocksWithJsonArray } from 'blockly/core';

import { beginnerTimeField } from '../helpers/block-builders.js';
import { beginnerPinField } from '../pins/pin-selector.js';
import { BEGINNER_ACTIVE_BUZZER_ACTION_OPTIONS } from './sound-constants.js';

const SOUND_STYLE = 'beginner_sound_blocks';

const activeBuzzerBlockDefinitions = [
  {
    type: 'beginner_active_buzzer_turn',
    message0: 'turn buzzer %1 on pin %2',
    args0: [
      {
        type: 'field_dropdown',
        name: 'ACTION',
        options: BEGINNER_ACTIVE_BUZZER_ACTION_OPTIONS,
      },
      beginnerPinField('BUZZER_PIN', 'buzzer'),
    ],
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Turns an active buzzer on or off.',
    helpUrl: '',
  },
  {
    type: 'beginner_active_buzzer_beep',
    message0: 'beep buzzer on pin %1 for %2',
    args0: [
      beginnerPinField('BUZZER_PIN', 'buzzer'),
      beginnerTimeField('DURATION'),
    ],
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Beeps the active buzzer for a short time.',
    helpUrl: '',
  },
  {
    type: 'beginner_active_buzzer_beep_repeatedly',
    message0: 'beep buzzer on pin %1 %2 times',
    args0: [
      beginnerPinField('BUZZER_PIN', 'buzzer'),
      {
        type: 'field_number',
        name: 'COUNT',
        value: 3,
        min: 1,
        max: 50,
        precision: 1,
      },
    ],
    message1: 'ON time %1 OFF time %2',
    args1: [beginnerTimeField('ON_TIME'), beginnerTimeField('OFF_TIME')],
    previousStatement: null,
    nextStatement: null,
    style: SOUND_STYLE,
    tooltip: 'Beeps the active buzzer several times.',
    helpUrl: '',
  },
];

export function registerBeginnerActiveBuzzerBlocks(): void {
  defineBlocksWithJsonArray(activeBuzzerBlockDefinitions);
}
